import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../models/Paginator';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { GenericCrudComponent } from "../../../../shared/components/generic-crud/generic-crud.component"
import { Filter } from '../../../../models/GenericCRUD/Filter';

@Component({
  selector: 'app-examiner-configuration',
  standalone: true,
  imports: [
    RouterLink,
    GenericCrudComponent
  ],
  templateUrl: './examiner-configuration.component.html',
  styleUrl: './examiner-configuration.component.css'
})
export class ExaminerConfigurationComponent {

  tableColumns: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
    { name: 'Fecha de Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy' },
    { name: 'Fecha de Actualización', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy' },
  ];

  formFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' }
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' }
  ];

  form: GenericForm = {
    successTitle: 'Examinador creado correctamente',
    errorTitle: 'Error al crear examinador',
    method: 'POST',
    fields: this.formFields,
    name: 'examiner',
    createButtonTitle: 'Nuevo Examinador',
    cols: 1,
    createApiSlug: '/config/examiner/store',
    formTitle: 'Crear Examinador',
    formButtonTitle: 'Crear',
    width: '2xl'
  };

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      form: {
        method: 'PUT',
        successTitle: 'Examinador editado correctamente',
        errorTitle: 'Error al editar examinador',
        fields: this.formFieldsEdit,
        name: 'examiner',
        createButtonTitle: '',
        cols: 1,
        createApiSlug: '',
        originalUpdateApiSlug: '/config/examiner/update/{{id}}',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{name}}',
        formTitle: '',
        formButtonTitle: 'Guardar cambios',
        width: '2xl'
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536M9 11l6-6m2 2l2 2M4 20h4l10-10-4-4L4 20z"/></svg>',
      confirmation: false
    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7L5 7M10 11v6M14 11v6M5 7l1 12a2 2 0 002 2h8a2 2 0 002-2l1-12M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/></svg>',
      confirmation: true,
      questionText: '¿Desea eliminar el examinador?',
      deleteRowOnResponse: true,
      actionSlug: '/config/examiner/delete/{{id}}',
    }
  ];

  table: GenericTable<Paginator<any>> = {
    columns: this.tableColumns,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/examiner/index',
    paginate: true,
    name: 'examinadores',
    actions: this.tableActions
  };

  filters: Filter[] = [
    { type: 'search', key: 'name', operator: 'like', placeholder: 'Buscar por nombre' }
  ];

    genericCRUD: GenericCRUD<Paginator<any>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: true
  }
}